/**
* ...
* @author DefaultUser (Tools -> Custom Arguments...)
*/
/**
 * package: com.inq.ui
 * class: Stage
 * @extends com.inq.ui.Container 
 * @constructor
 */
com.inq.ui.Stage = function() {
	//We need to init com.inq.ui.Container with our instance element id but we have none.
	//Using the global window.frameElement directly in "overridden" determineExistingElement method
	com.inq.ui.Container.call(this);

	if(com.inq.ui.Stage.stage == null) {
		com.inq.stage.ViewportMgr.init();
		com.inq.ui.Stage.stage = this;
	} else throw "Stage is not a singleton";

	com.inq.ui.Stage._dragBar = com.inq.ui.Container._getElementById("inqTitleBar",parent.document);
};
$hxClasses.extend(com.inq.ui.Container, com.inq.ui.Stage, "com.inq.ui.Stage");

/** @type {number} */
com.inq.ui.Stage.height = null;
/** @type {number} */
com.inq.ui.Stage.width = null;
/** @type {number} */
com.inq.ui.Stage.stageLeft = null;
/** @type {number} */
com.inq.ui.Stage.stageTop = null;

/**
 * Public override function to properly use our target element and NOT id!
 *
 * @override
 * @param {string} _id
 * @return {HTMLElement}
 */
com.inq.ui.Stage.prototype.determineExistingElement = function(_id){
	return window.frameElement;
};

/**
 * getInstance
 * getStage - Return the instance of stage
 *
 * $type TFun([],TInst(com.inq.ui.Stage,[]))
 * public static function getInstance()
 * @public
 * @static
 * @return {com.inq.ui.Stage}
 */
com.inq.ui.Stage.getInstance = function() {
	if(com.inq.ui.Stage.stage == null) {
		com.inq.ui.Stage.stage = new com.inq.ui.Stage();
	} 	
	return com.inq.ui.Stage.stage;
};


/**
 * getterStageHeight
 * getter for the stage's height
 * If the stage's (AKA: iframe) style has a percent in it,
 * then we cannot use it to get the height;
 * We must get the iframe's inner height - for gecko based browsers
 * Or we must get the offsetHeight - for IE based browsers
 *
 * $type TFun([],TInst(Int,[]))
 * private static function getterStageHeight():Int
 * @private
 * @static
 * @return {number} - integer value of the height of the stage
 */
com.inq.ui.Stage.getterStageHeight = function() {
	/** @type {number} */
	var stageHeight;
	/** @type {CSSStyleDeclaration} */
	var style = com.inq.flash.client.control.FlashPeer.noV3FrameChat() ?  Application.application.stg.style : window.frameElement.style;
	stageHeight = style.height.indexOf("%") >= 0 ?
		window["innerHeight"] != null ? window.innerHeight : com.inq.ui.Stage.getOffsetHeight() :
		Std.parseInt(style.height);
	return stageHeight;
};


/**
 * getterStageWidth
 * getter for the stage's width
 * If the stage's (AKA: iframe) style has a percent in it,
 * then we cannot use it to get the width;
 * We must get the iframe's inner width - for gecko based browsers
 * Or we must get the offsetWidth - for IE based browsers
 *
 * $type TFun([],TInst(Int,[]))
 * private static function getterStageWidth():Int
 * @private
 * @static
 * @return {number} - integer value of the width of the stage
 */
com.inq.ui.Stage.getterStageWidth = function() {
	/** @type {number} */
	var stageWidth;
	/** @type {CSSStyleDeclaration} */
	var style = com.inq.flash.client.control.FlashPeer.noV3FrameChat() ?  Application.application.stg.style : window.frameElement.style;
	stageWidth = style.width.indexOf("%") >= 0 ?
		window["innerWidth"] != null ? window.innerWidth : com.inq.ui.Stage.getOffsetWidth() :
		Std.parseInt(style.width);
	return stageWidth;
};


/**
 * getOffsetHeight
 * gets window's offsetHeight,
 * This is used only by Persisent chat on IE browsers
 *
 * $type TFun([],TInst(Int,[]))
 * private static function getOffsetHeight():Int
 * @private
 * @static
 * @see getterStageHeight - the only reference.
 * @return {number} - integer value of the offset Height of the stage
 */
com.inq.ui.Stage.getOffsetHeight = function() {
	/** @type {number} */
	var iOffsetHeight = 0;
	/** @type {Window} */
	var iframeWin = window;
	/** @type {Document} */
	var iframeDoc = iframeWin.document;
	if(null == iframeWin["innerHeight"]) {
		iOffsetHeight = iframeDoc["documentElement"] != null?0 != iframeDoc.documentElement.offsetHeight?iframeDoc.documentElement.offsetHeight:iframeDoc.body.offsetHeight:iframeDoc.body.offsetHeight;
		if(0 == iOffsetHeight) iOffsetHeight = iframeDoc.body.offsetHeight;
	} else 
	iOffsetHeight = iframeWin.innerHeight;
	return iOffsetHeight;
};


/**
 * getStageLeft
 *
 * $type TFun([],TInst(Int,[]))
 * public static function getStageLeft():Int
 * @public
 * @static
 * @return {number}
 */
com.inq.ui.Stage.getStageLeft = function() {
	return Std.parseInt(com.inq.ui.Stage.getStageElement().style.left);
};


/**
 * getStageTop
 *
 * $type TFun([],TInst(Int,[]))
 * public static function getStageTop():Int
 * @public
 * @static
 * @return {number}
 */
com.inq.ui.Stage.getStageTop = function() {
	return Std.parseInt(com.inq.ui.Stage.getStageElement().style.top);
};


/**
 * getOffsetWidth
 * gets window's offsetWidth,
 * This is used only by Persisent chat on IE browsers
 *
 * $type TFun([],TInst(Int,[]))
 * private static function getOffsetWidth():Int
 * @private
 * @static
 * @see getterStageWidth - the only reference.
 * @return {number} - integer value of the offset width of the stage
 */
com.inq.ui.Stage.getOffsetWidth = function() {
	/** @type {number} */
	var iOffsetWidth = 0;
	/** @type {Window} */
	var iframeWin = window;
	/** @type {Document} */
	var iframeDoc = iframeWin.document;
	if(null == iframeWin["innerWidth"]) {
		iOffsetWidth = iframeDoc["documentElement"] != null?0 != iframeDoc.documentElement.offsetWidth?iframeDoc.documentElement.offsetWidth:iframeDoc.body.offsetWidth:iframeDoc.body.offsetWidth;
		if(0 == iOffsetWidth) iOffsetWidth = iframeDoc.body.offsetWidth;
	} else 
	iOffsetWidth = iframeWin.innerWidth;
	return iOffsetWidth;
};


/**
 * getStageElement: private method that returns the stage base element (_div).
 * In doing so it determines whether-or-not we are a skin in client body or in the IFRAME.
 * If it newly discovered to be in the client body, (having the name "tcChat_Skin", ...
 * ... Then we fix the stage to reference it instead.
 * 
 * The stage base element is not necessarily a div.  It is more likely to be an IFRAME.
 *
 * $type TFun([],TDynamic(null))
 * public static function getStageElement():Dynamic
 * @public
 * @static
 * @return {null} - stage._div, the stage base element
 */
com.inq.ui.Stage.getStageElement = function() {
	try {
		if(!com.inq.ui.Stage.stage) {return null;};
		/* Determine whether-or-not the stage is in the IFrame */
		/** @type {?HTMLElement} */
		var skinDiv = com.inq.ui.Container._getElementById("tcChat_Skin",parent.document);
		if(skinDiv != null) {
			if(com.inq.ui.Stage.stage._div != skinDiv) {
				skinDiv.style.cssText = com.inq.ui.Stage.stage._div.style.cssText;/* No, so let's register it as the stage element */
				/* Re-establish width and height, this is so that we rebuild the drag bar and corner resize image */
				/** @type {number} */
				var width = Std.parseInt(com.inq.ui.Stage.stage._div.style.width);/* Get the width from the IFRAME */
				/** @type {number} */
				var height = Std.parseInt(com.inq.ui.Stage.stage._div.style.height);/* Get the height from the IFRAME */
				/** @type {?HTMLElement} */
				var iframe = com.inq.flash.client.control.FlashPeer.noV3FrameChat()? Application.application.stg: window.frameElement;/* Get the iframe */
				if(iframe != null) iframe.style.display = "none";/* Hide the iframe *//* Hide the iframe */
				com.inq.ui.Stage.stage._div = skinDiv;/* Replace the iframe with the div for this case */
				Application.MoveSizeDiv2Stage(width,height);/* use the move/resize to rebuild the drag and resize divs */
			}/* Yes, ? is it the registered _div ? *//* ? Is the "client" skin there ? */
		}/* ? Is the "client" skin there ? *//* ? Is the "client" skin there ? */
	} catch( e ) {
	}
	return com.inq.ui.Stage.stage._div;
};


/**
 * setObjectFocus
 *
 * $type TFun([{ name => object, t => TDynamic(null), opt => false }],TDynamic(null))
 * private function setObjectFocus(object:Dynamic):Dynamic
 * @private
 * @this com.inq.ui.Stage
 * @param {null}  object 
 * @return {null}
 */
com.inq.ui.Stage.prototype.setObjectFocus = function(object) {
	this.focus = object;
	object.setFocus();
};


/**
 * getVisible
 * visible getter
 * gets the visibility for the stage
 *
 * $type TFun([{ name => _visible, t => TDynamic(null), opt => false }],TEnum(Void,[]))
 * override private function setVisible(_visible:Dynamic):Void
 * @public
 * @override 
 * @this com.inq.ui.Stage
 * @return {boolean} true if visible
 */
 com.inq.ui.Stage.prototype.getVisible = function(_visible) {
	return (this._div.style.display != "none");
};

/**
 * setVisible
 * visible setter
 * sets the visibility for the container
 *
 * $type TFun([{ name => _visible, t => TDynamic(null), opt => false }],TEnum(Void,[]))
 * override private function setVisible(_visible:Dynamic):Void
 * @override
 * @private
 * @this com.inq.ui.Stage
 * @param {null}  _visible - set to true or false, it will accept a boolean true or false or a string "true" or "false" 
 * @return {void}
 */
com.inq.ui.Stage.prototype.setVisible = function(_visible) {
	try {
		/* Determine whether-or-not the stage is in the IFrame */
		com.inq.ui.Stage.getStageElement();
		com.inq.stage.ViewportMgr.visible(_visible);
		this.styles.visible = _visible?"true":"false";
		this._div.style.display = _visible?"":"none";
		
		/* Now hide/show the corner and drag bar
		 * but only if we are non-persistent.
		 * We do not want the corner and drag bar to appear in persistent chat
		 */
		if(!Application.IsPersistent()) {
			com.inq.ui.Stage._dragBar.style.display = _visible?"":"none";
			Application.application.setVisibleResizeCorner(_visible);
		}

	} catch( e ) {
		haxe.Log.trace(e,{ fileName : "Stage.hx", lineNumber : 58, className : "com.inq.ui.Stage", methodName : "setVisible"});
	}
};


/** @type {null} */
com.inq.ui.Stage.prototype.focus = null;
/** @type {com.inq.ui.Stage} */
com.inq.ui.Stage.prototype.__class__ = com.inq.ui.Stage;
/** @private @type {null} */
com.inq.ui.Stage._dragBar = null;

/** @private @type {com.inq.ui.Stage} */
com.inq.ui.Stage.stage = null;

